<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">
          Kontoinnstillinger
          <span style="opacity: 0.7;">&raquo; {{kunde.full_name}} &raquo; {{kunde.Kundenr}}</span>
        </h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onKundeCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="onSaveButtonClick()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onKundeCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <KundeCardForm :kunde="kunde"/>
  </div>
</template>

<script>
import KundeCardForm from './KundeCardForm'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeCardEdit',
  components: {
    KundeCardForm
  },
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  /**
   * Remove beforeDestroy & created, if no sidebar showld be on edit page...
   */
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')
  },
  methods: {
    onKundeCancel: function () {
      this.$emit('switchKundeView', false)
    },
    onSaveButtonClick: function () {
      bus.$emit('kunde-form-submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardEdit.vue